import { Button, Dialog } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { useAuthStore } from '../../../stores/auth';
import { LoiTrongHop } from '../../tenant/components/phan-form';
import type { UserProfile } from '../types';

/**
 * Hộp xác nhận bắt buộc một người xác thực hai lớp (`PATCH` với
 * `mfa_required: true`, ADR-0015 mức "người được chọn").
 *
 * Thân nói hậu quả theo đúng người: bị đăng xuất ngay, lần đăng nhập sau phải
 * nhập OTP — và phải cài ứng dụng trước nếu `mfa_configured` là `false`. Bật
 * cho chính mình thì nói thẳng là bạn bị đăng xuất. Lỗi (`503` khi Keycloak
 * không trả lời) hiện **trong** hộp, hộp không đóng.
 */
export function HopBatBuocMfa({
  open,
  nguoi,
  dangChay,
  loi,
  onClose,
  onXacNhan,
}: {
  open: boolean;
  /** Giữ nguyên khi hộp đang đóng, để tiêu đề không nháy trống lúc mờ dần. */
  nguoi: UserProfile | null;
  dangChay: boolean;
  loi: unknown;
  onClose: () => void;
  onXacNhan: (nguoi: UserProfile) => void;
}) {
  const { t } = useT();
  const dichLoi = useLoi();
  const toiLa = useAuthStore((s) => s.user?.id);
  const ten = nguoi?.display_name ?? '';
  const than =
    nguoi?.user_id === toiLa
      ? 'nguoiDung.mfa.xnThanBan'
      : nguoi?.mfa_configured === false
        ? 'nguoiDung.mfa.xnThanChuaCai'
        : 'nguoiDung.mfa.xnThan';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('nguoiDung.mfa.xnTieuDe', { ten })}
      width={480}
      destroyOnHidden
      footer={
        <div className="flex flex-wrap justify-end gap-3">
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.huy')}
          </Button>
          <Button
            variant="primary"
            size="md"
            loading={dangChay}
            onClick={() => nguoi && onXacNhan(nguoi)}
          >
            {t('nguoiDung.mfa.batBuocMuc')}
          </Button>
        </div>
      }
    >
      <div className="space-y-3 pt-2">
        <p className="text-sm leading-relaxed text-content-secondary">{t(than)}</p>
        {Boolean(loi) && <LoiTrongHop>{dichLoi(loi)}</LoiTrongHop>}
      </div>
    </Dialog>
  );
}
